import React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import ReactCountryFlag from "react-country-flag";

// import navigation data
import { navigationData } from "../../dataEn";

const NavMobile = (props) => {
  const code = props.currentLanguage === "id" ? "ID" : "GB";
  return (
    <ul className="flex flex-col px-6 py-8 h-full gap-y-4 bg-primary">
      {navigationData.map((item, index) => {
        return (
          <li key={index}>
            <a
              className="text-white"
              href={item.href}
              onClick={() => props.mobile(false)}
            >
              {item.name}
            </a>
          </li>
        );
      })}
      <div className="flex items-center gap-x-1 pl-0">
        <ReactCountryFlag countryCode={code} svg />
        <select
          id="countriesMobile"
          className="h5 text-white font-semibold bg-primary border-none cursor-pointer outline-none"
          value={props.currentLanguage}
          onChange={(e) => props.onChangeLanguage(e.target.value)}
        >
          <option value="id">ID</option>
          <option value="en">EN</option>
        </select>
      </div>
    </ul>
  );
};

export default NavMobile;
